import React from 'react';
import { 
  Hotel, 
  Wifi, 
  Coffee, 
  Dumbbell, 
  Waves, 
  Globe, 
  Mail, 
  Plane, 
  MapPin, 
  Info,
  CheckCircle2,
  Users,
  User
} from 'lucide-react';

const HotelInfor = () => {
  const hotelData = {
    name: "Hotel Sonesta",
    location: "Loja, Ecuador",
    description: "Hotel sede oficial del encuentro. Punto exclusivo de salida para el transporte hotel-universidad-hotel.",
    website: "www.sonestaloja.com",
    emails: ["mercadeo@sonestaloja.com", "reservas@sonestaloja.com"],
    rates: [
      { type: "Habitación Sencilla", price: "67.00", icon: <User size={20} /> },
      { type: "Habitación Doble", price: "77.00", icon: <Users size={20} /> }
    ],
    amenities: [
      { name: "Desayuno buffet", icon: <Coffee size={20} /> },
      { name: "Wifi de alta velocidad", icon: <Wifi size={20} /> },
      { name: "Gimnasio", icon: <Dumbbell size={20} /> },
      { name: "Piscina, turco e hidromasaje", icon: <Waves size={20} /> }
    ],
    transfers: [
      { type: "Uso exclusivo", price: "25.00" },
      { type: "Uso compartido", price: "12.00" }
    ]
  };

  return (
    <div className="page-wrapper">
      <style>{`
        .page-wrapper {
          min-height: 100vh;
          background-color: white;
          padding: 2rem 1rem;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          font-family: system-ui, -apple-system, sans-serif;
        }

        .card {
          max-width: 900px;
          width: 100%;
          background: white;
          border-radius: 1.5rem;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          border: 1px solid #e2e8f0;
        }

        .header {
          position: relative;
      
          background-color: #004270;
          display: flex;
          align-items: flex-end;
          color: white;
        }

        .header-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
        }

        .header-placeholder {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          color: rgba(255,255,255,0.1);
              background: #004270;
        }

        .header-content {
          position: relative;
          padding: 2rem;
          width: 100%;
        }

        .badge {
          display: inline-block;
          padding: 0.25rem 0.75rem;
          background-color: #2563eb;
          font-size: 0.75rem;
          font-weight: 700;
          text-transform: uppercase;
          border-radius: 9999px;
          margin-bottom: 0.5rem;
        }

        .title {
          font-size: 2.25rem;
          font-weight: 800;
          margin: 0;
        }

        .location {
          display: flex;
          align-items: center;
          color: #cbd5e1;
          margin-top: 0.5rem;
          font-size: 0.9rem;
        }

        .alert-box {
          background-color: #fffbeb;
          border-left: 4px solid #f59e0b;
          padding: 1rem;
          display: flex;
          gap: 0.75rem;
          align-items: flex-start;
        }

        .alert-text {
          color: #92400e;
          font-weight: 500;
          font-size:10pt;
          margin: 0;
        }

        .main-grid {
          display: grid;
          grid-template-columns: 1fr;
        }

        @media (min-width: 768px) {
          .main-grid {
            grid-template-columns: 1fr 1fr;
          }
        }

        .column-left {
          padding: 2rem;
          border-right: 1px solid #f1f5f9;
        }

        .column-right {
          padding: 2rem;
          background-color: #f8fafc;
        }

        .section-title {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1e293b;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin-bottom: 1.5rem;
        }

        .rate-card {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          background-color: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 1rem;
          margin-bottom: 1rem;
          transition: border-color 0.2s;
        }

        .rate-card:hover {
          border-color: #93c5fd;
        }

        .rate-info {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .icon-container {
          padding: 0.5rem;
          background: white;
          border-radius: 9999px;
          color: #2563eb;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }

        .price {
          font-size: 1.5rem;
          font-weight: 700;
          color: #0f172a;
        }

        .tax-note {
          font-size: 0.75rem;
          color: #64748b;
          font-style: italic;
        }

        .amenities-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0.75rem;
        }

        .amenity-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.875rem;
          color: #475569;
        }

        .transfer-box {
          background: white;
          padding: 1.5rem;
          border-radius: 1rem;
          border: 1px solid #e2e8f0;
          margin-bottom: 2rem;
        }

        .transfer-row {
          display: flex;
          justify-content: space-between;
          padding: 0.5rem 0;
          border-bottom: 1px solid #f1f5f9;
        }

        .transfer-row:last-child {
          border-bottom: none;
        }

        .contact-link {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 0.75rem;
          border-radius: 0.75rem;
          text-decoration: none;
          color: #1e293b;
          transition: all 0.2s;
        }

        .contact-link:hover {
          background: white;
          box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);
        }

        .link-blue { color: #2563eb; text-decoration: underline; }

        
      `}</style>

      <div className="card">
        {/* Header */}
        <div className="header">
  
         
          <div className="header-content">
            <span className="badge">Hotel sede del encuentro</span>
            <h1 className="title">{hotelData.name}</h1>
            <div className="location">
              <MapPin size={16} style={{marginRight: '4px'}} />
              {hotelData.location}
            </div>
          </div>
        </div>

        {/* Alerta */}
        <div className="alert-box">
          <Info size={24} color="#d97706" />
          <p className="alert-text">
            <strong>Importante:</strong> El transporte hotel-universidad-hotel únicamente saldrá de esta ubicación.
          </p>
        </div>

        <div className="main-grid">
          {/* Columna Izquierda */}
          <div className="column-left">
            <h2 className="section-title">
              <CheckCircle2 color="#2563eb" size={24} />
              Tarifas Preferenciales (código: UTPL)
            </h2>
            
            {hotelData.rates.map((rate, idx) => (
              <div key={idx} className="rate-card">
                <div className="rate-info">
                  <div className="icon-container">{rate.icon}</div>
                  <span style={{fontWeight: 500}}>{rate.type}</span>
                </div>
                <div className="price">USD {rate.price}</div>
              </div>
            ))}
            <p className="tax-note">* Tarifas sujetas a impuestos (15% IVA - 10% Servicios)</p>

            <h3 style={{fontSize: '1.1rem', marginTop: '2rem', marginBottom: '1rem'}}>La tarifa incluye:</h3>
            <div className="amenities-grid">
              {hotelData.amenities.map((item, idx) => (
                <div key={idx} className="amenity-item">
                  <span style={{color: '#3b82f6'}}>{item.icon}</span>
                  {item.name}
                </div>
              ))}
            </div>
          </div>

          {/* Columna Derecha */}
          <div className="column-right">
            <h2 className="section-title">
              <Plane color="#2563eb" size={24} />
              Transfer Aeropuerto
            </h2>
            <div className="transfer-box">
              <p style={{fontSize: '0.8rem', color: '#64748b', marginBottom: '1rem'}}>(Previa confirmación)</p>
              {hotelData.transfers.map((item, idx) => (
                <div key={idx} className="transfer-row">
                  <span>{item.type}</span>
                  <span style={{fontWeight: 700}}>USD {item.price}</span>
                </div>
              ))}
            </div>

            <h2 className="section-title">
              <Globe color="#2563eb" size={24} />
              Contacto y Reservas
            </h2>
            <div className="contact-list">
              <a href={`https://${hotelData.website}`} className="contact-link" target="_blank" rel="noreferrer">
                <div className="icon-container"><Globe size={18} /></div>
                <span className="link-blue">{hotelData.website}</span>
              </a>
              {hotelData.emails.map((email, idx) => (
                <a key={idx} href={`mailto:${email}`} className="contact-link">
                  <div className="icon-container" style={{color: '#475569'}}><Mail size={18} /></div>
                  <span style={{fontWeight: 500}}>{email}</span>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
    
      </div>
    </div>
  );
};

export default HotelInfor;